import rawConfig from '../config/pokedex.config.json';

export const config = rawConfig;
export type AppConfig = typeof rawConfig;

export function assetUrl(relativePath: string): string {
  const base = import.meta.env.BASE_URL || '/';
  return new URL(relativePath.replace(/^\//, ''), `${window.location.origin}${base}`).toString();
}
